import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=e1ed4bcc&scoped=true&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=e1ed4bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ed4bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1ed4bcc')) {
      api.createRecord('e1ed4bcc', component.options)
    } else {
      api.reload('e1ed4bcc', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=e1ed4bcc&scoped=true&", function () {
      api.rerender('e1ed4bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/PageHeader.vue"
export default component.exports